<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="引荐类型：" prop="mail">
                <span>{{ transEnu(model.recommend_type, "recommend_type") }}</span>
            </el-form-item>
            <el-form-item label="老用户邮箱：" prop="mail">
                <span>{{model.mail}}</span>
            </el-form-item>
            <el-form-item label="新用户姓名：" prop="new_name">
                <span>{{model.new_name}}</span>
            </el-form-item>
            <el-form-item label="新用户邮箱：" prop="new_mail">
                <span>{{model.new_mail}}</span>
            </el-form-item>
            <el-form-item label="新用户手机号：" prop="new_cellnum">
                <span>{{model.new_cellnum}}</span>
            </el-form-item>
            <el-form-item label="地区：" prop="province">
                <span>{{model.province}} {{model.city}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="是否回填：" prop="is_back">
                <span>{{ transEnu(model.is_back, "yesNo") }}</span>
            </el-form-item>
            <el-form-item label="凭证图片：" prop="proof_img" v-if="model.is_back==1">
                <el-image style="width: 100px; height: 220px" :src="model.proof_img" title="点击查看大图" :preview-src-list="[model.proof_img]"></el-image>
            </el-form-item>
            <el-form-item label="回填时间：" prop="back_time" v-if="model.is_back==1">
                <span>{{model.back_time}}</span>
            </el-form-item>
            <el-form-item label="是否处理：" prop="state" v-if="model.is_back==1">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNO'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" prop="remark" v-if="model.is_back==1">
                <el-input v-model="model.remark" type="textarea" rows="4" size="medium"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'testDriveRecommendEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                mail: '',
                new_name: '',
                new_mail: '',
                new_cellnum: '',
                province: '',
                city: '',
                add_time: '',
                is_back: '',
                proof_img: '',
                back_time: '',
                state: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/testdriverecommend/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['recommend_type', 'yesNo'],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/testdriverecommend/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData() {
            this.model.state = this.model.state+""
        },
    }
};
</script>